<template>

  <div class="contentMainDiv">


		<span style="color:red;">{{message}}</span>

		<div class="noticeDiv">
			<b>お知らせ</b><br>
			<textarea class="inputArea" style="font-size:14px;width:700px;height:400px;" v-model="notice.contents"></textarea>
			<div class="inputItemDiv" v-show="!resNoticeVal"><span class="validateError">入力必須。1000桁以内で入力して下さい。</span></div>

		</div>
		
		<div class="operationDiv" style="width:720px;">
		<button :disabled="!resNoticeVal" type="button" @click="regist" style="float: right"  class="button">登録</button>
		</div>

	</div>

</template>

<script>

import { ref } from 'vue'
import noticeRepository from '../composables/NoticeRepository'
import noticeValidator from '../composables/NoticeValidator'

export default ({
  name: 'RegistNotice',
  setup(){
    
    const notice = ref({id:'',contents:''})
    const { registNotice, getLatestNotice } = noticeRepository()
    const { resNoticeVal } = noticeValidator( notice )
    const message = ref("")


    const regist = () =>{
      console.log( notice )
      registNotice( notice.value, regCallback )
    }
    const regCallback = ( result ) =>{
      if( result == "success"){
        message.value = "登録完了"
      }else{
        message.value = result
      }
      
    }
    
    const callbackNotice = ( result, data ) =>{
      if( result == "success" ){
        console.log( data)
        notice.value = data
      }
    }
    
    notice.value = getLatestNotice( callbackNotice )
    
    //template上で使用する変数を宣言
    return{
      notice,
      regist,
      message,
      resNoticeVal
    }
  }
})

</script>

